import { WeddingInfoType } from "./WeddingInfo";

const firebaseStorageURL = (name: string) =>
  `https://firebasestorage.googleapis.com/v0/b/marriage-1e74b.firebasestorage.app/o/${name}.jpg?alt=media`;

export const YounghunWeddingInfo: WeddingInfoType = {
  common: {
    groomName: "안영훈",
    brideName: "박주원",
    groomShortName: "영훈",
    brideShortName: "주원",
    addressInfo: {
      name: "하우스 오브 드메르, 아벨린 홀 (3층)",
      lat: 35.208157,
      lon: 126.82183,
      address: "광주광역시 광산구 임방울대로 549",
      naverAddress:
        "https://map.naver.com/p/search/%EA%B4%91%EC%A3%BC%20%EB%93%9C%EB%A9%94%EB%A5%B4/place/580623277?c=15.00,0,0,0,dh&placePath=/information",
    },
    weddingDateKR: "2025년 06월 15일 일요일 오후 2시",
    weddingDate: "2025-06-15T14:00:00",
    groomAccountInfos: [
      {
        name: "안경수",
        bankName: "농협은행",
        bankImage: `${process.env.PUBLIC_URL}/nonghyupbank.png`,
        accountNumber: "677-02-099925",
        isGroom: true,
        familyName: "父",
      },
      {
        name: "김미라",
        bankName: "농협은행",
        bankImage: `${process.env.PUBLIC_URL}/nonghyupbank.png`,
        accountNumber: "641043-51-104171",
        isGroom: true,
        familyName: "母",
      },
    ],
    brideAccountInfos: [
      {
        name: "박성욱",
        bankName: "하나은행",
        bankImage: `${process.env.PUBLIC_URL}/hanabank.jpeg`,
        accountNumber: "709-910111-22307",
        isGroom: false,
        familyName: "父",
      },
      {
        name: "이선희",
        bankName: "농협은행",
        bankImage: `${process.env.PUBLIC_URL}/nonghyupbank.png`,
        accountNumber: "312-0001-7170-81",
        isGroom: false,
        familyName: "母",
      },
    ],
    accountInfos: [
      {
        name: "안영훈",
        bankName: "토스뱅크",
        bankImage: `${process.env.PUBLIC_URL}/toss.jpeg`,
        accountNumber: "1001-2634-3421",
        isGroom: true,
        familyName: "",
      },
      {
        name: "박주원",
        bankName: "카카오뱅크",
        bankImage: `${process.env.PUBLIC_URL}/kakaobank.png`,
        accountNumber: "3333-21-2719127",
        isGroom: false,
        familyName: "",
      },
    ],
    parentBGM: null,
    netflixBGM: null,
    spotifyBGM: null,
    instagramBGM: null,
  },
  parent: {
    startPhrase: "영훈 그리고 주원",
    shortPhrase: "결혼합니다",
    mainImage: firebaseStorageURL("green10"),

    weddingMessage: `푸른 여름 하늘 아래,

저희 두 사람이 하나 되는 특별한 날을 맞이합니다.

강렬한 햇살처럼 서로에게 뜨겁고 진실한 마음으로 함께하겠다는 굳은 약속을 하려고 합니다.

저희의 결혼식에 참석하시어 따뜻한 축복을 해 주시면 감사하겠습니다.`,
    groomFatherName: "안경수",
    groomMotherName: "김미라",
    groomFamilyTitle: "장남",
    brideFatherName: "박성욱",
    brideMotherName: "이선희",
    brideFamilyTitle: "장녀",
    photoGalleryPhrase: "우리들의 아름다운 추억들",
    photoGalleryImages: [
      firebaseStorageURL("green13"),
      firebaseStorageURL("green1"),
      firebaseStorageURL("green2"),
      firebaseStorageURL("green3"),
      firebaseStorageURL("green4"),
      firebaseStorageURL("river1"),
      firebaseStorageURL("bridge3"),
      firebaseStorageURL("bridge4"),
      firebaseStorageURL("bridge5"),
      firebaseStorageURL("bridge8"),
      firebaseStorageURL("bridge10"),
    ],
    poetry: `사랑의 약속

두 사람이 걷습니다
한 사람의 길이 아닌
둘만의 길을 함께 만들어 갑니다.

오늘의 이 약속이
평생의 봄날이 되기를.`,

    endImage: firebaseStorageURL("bridge7"),
  },
  instagram: {
    storyImages: [
      `${process.env.PUBLIC_URL}/couple/juwon5.jpeg`,
      `${process.env.PUBLIC_URL}/couple/younghun1.jpeg`,
      `${process.env.PUBLIC_URL}/couple/juwon4.jpeg`,
      `${process.env.PUBLIC_URL}/couple/younghun2.jpeg`,

      `${process.env.PUBLIC_URL}/couple/juwon12.jpeg`,
      `${process.env.PUBLIC_URL}/couple/younghun4.jpeg`,
      `${process.env.PUBLIC_URL}/couple/juwon2.jpeg`,
      `${process.env.PUBLIC_URL}/couple/younghun3.jpeg`,
      `${process.env.PUBLIC_URL}/couple/juwon9.jpeg`,
    ],
    postInfos: [
      {
        profileImage: firebaseStorageURL("bridge2"),
        name: "영훈 ❤️ 주원",
        postImages: [
          firebaseStorageURL("green13"),
          firebaseStorageURL("green10"),
          firebaseStorageURL("green1"),
          firebaseStorageURL("green2"),
          firebaseStorageURL("green3"),
          firebaseStorageURL("green4"),
          firebaseStorageURL("green5"),
          firebaseStorageURL("green6"),
          firebaseStorageURL("green7"),
          firebaseStorageURL("green8"),
          firebaseStorageURL("green9"),
          firebaseStorageURL("green12"),
          firebaseStorageURL("green11"),
        ],
        title: "항상 늘 웃으며 서로를 사랑하겠습니다. 🤵🏻👰🏻",
        caption: "모두 축하해주셔서 감사합니다.",
      },
      {
        profileImage: firebaseStorageURL("bridge2"),
        name: "영훈 ❤️ 주원",
        postImages: [
          firebaseStorageURL("bridge1"),
          firebaseStorageURL("bridge2"),
          firebaseStorageURL("bridge3"),
          firebaseStorageURL("bridge4"),
          firebaseStorageURL("bridge11"),
          firebaseStorageURL("bridge5"),
          firebaseStorageURL("river1"),
          firebaseStorageURL("river2"),
          firebaseStorageURL("bridge6"),
          firebaseStorageURL("bridge7"),
          firebaseStorageURL("bridge8"),
          firebaseStorageURL("bridge9"),
          firebaseStorageURL("bridge10"),
        ],
        title: "행복하게 잘 살겠습니다! 🙇🏻🙇🏻‍♀️",
        caption: "귀한 발걸음 해주셔서 감사드립니다.",
      },
    ],
    gridInfo: {
      profileImage: firebaseStorageURL("couple1"),
      name: "Our Memories",
      startDay: "2020-07-11",
      images: [
        firebaseStorageURL("couple2"),
        `${process.env.PUBLIC_URL}/couple/our-memory-1.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-2.jpeg`,
        `${process.env.PUBLIC_URL}/couple/couple3.jpeg`,
        `${process.env.PUBLIC_URL}/couple/couple1.jpg`,
        `${process.env.PUBLIC_URL}/couple/couple4.jpg`,
        `${process.env.PUBLIC_URL}/couple/couple2.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-6.jpeg`,
        `${process.env.PUBLIC_URL}/couple/couple5.jpeg`,
      ],
    },
  },
  spotify: {
    albumTitle: "영훈이와 주원이의 행복 리스트",
    albums: [
      {
        mainImage: `${process.env.PUBLIC_URL}/couple/our-memory-1.jpeg`,
        title: "인생네컷",
        caption: "영훈이랑 주원이",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/couple/our-memory-2.jpeg`,
        title: "처음 어머니 뵙던 날",
        caption: "영천영화",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/couple/our-memory-3.jpeg`,
        title: "안경집",
        caption: "선글라스",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/couple/our-memory-4.jpeg`,
        title: "영훈이 옥탑",
        caption: "삼겹살",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/couple/our-memory-5.jpeg`,
        title: "귀여운 쭈워니",
        caption: "젠틀 몬스터",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/couple/our-memory-6.jpeg`,
        title: "여름 롯데백화점",
        caption: "HDEX",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/couple/couple2.jpeg`,
        title: "쭈워니랑 거울보고",
        caption: "집 앞 편의점",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/couple/couple3.jpeg`,
        title: "인생네컷",
        caption: "올블랙",
        topRightCaption: "Love",
      },
    ],
    lyricTitle: "전하고 싶은 말",
    lyrics: [
      {
        message: `인생 가장 빛나는 날,

          소중한 분들을 모시고 기쁨을 나누면 좋겠지만
          혹 참석이 어려우시더라도 괜찮습니다.

          멀리서 축하해주신 분들과 어려운 발걸음
          해주신 분들 모두 마음에 새기고 항상 행복하게 살겠습니다.`,
        hightlightLines: [0],
        color: "bg-red-500/80",
      },
      {
        message: `이 두 사람을 지성으로 아끼고 돌봐주신
          여러 어른과 친지를 모시고 서약을 맺고자 하오니

          바쁘신 가운데 두 사람의 앞날을
          가까이에서 축복해 주시면 고맙겠습니다.

          감사합니다.`,
        hightlightLines: [3],
        color: "bg-spotify/80",
      },
      {
        message: `안영훈 ♥ 박주원

            고독한 마라톤인 줄로만 알았습니다
            재촉하지 않고 더 오래 걷자고
            
       서로의 다리에 결혼이라는 끝을 묶고
      달리기로 했습니다.

            황홀하게 기억하겠습니다. 
            출발선에 선 이 순간을`,
        hightlightLines: [0, 5, 6],
        color: "bg-yellow-500/80",
      },
    ],
    player: {
      sectionTitle: "우리들의 이야기",
      videoURL: `${process.env.PUBLIC_URL}/couple.MOV`,
      title: "우리 결혼해요! (feat. 축하해주세요)",
      caption: "영훈 ❤️ 주원",
    },
    list: {
      sectionTitle: "인기 급상승 추억 리스트",
      images: [
        `${process.env.PUBLIC_URL}/couple/our-memory-1.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-2.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-3.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-4.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-5.jpeg`,
      ],
      titles: [
        "인생네컷",
        "처음 어머니 뵙던 날",
        "안경집",
        "영훈이 옥탑",
        "귀여운 쭈워니",
        "여름 롯데백화점",
        "쭈워니랑 거울보고",
        "인생네컷",
      ],
      captions: [
        "영훈이랑 주원이",
        "영천영화",
        "선글라스",
        "삼겹살",
        "젠틀 몬스터",
        "HDEX",
      ],
    },
    artist: {
      sectionTitle: "여러 장소 리스트",
      images: [
        `${process.env.PUBLIC_URL}/couple/juwon1.jpeg`,
        `${process.env.PUBLIC_URL}/couple/younghun1.jpeg`,
        `${process.env.PUBLIC_URL}/couple/juwon2.jpeg`,
        `${process.env.PUBLIC_URL}/couple/younghun2.jpeg`,
        `${process.env.PUBLIC_URL}/couple/juwon3.jpeg`,
        `${process.env.PUBLIC_URL}/couple/younghun3.jpeg`,
      ],
      titles: ["쭈워니", "영훈", "쭈워닝", "영훈이", "쭈워닝", "영훈이"],
      captions: [
        "카페에서",
        "아웃백에서",
        "잠실역에서",
        "삼겹살 집에서",
        "집 옥탑에서",
        "카페에서",
      ],
    },
  },
  netflix: {
    posterInfo: {
      image: `${process.env.PUBLIC_URL}/couple/wedding-sample-2.jpg`,
      title: " 우리들의 결혼 이야기",
      caption: "2025년 6월 15일 최초 공개",
    },
    top10Info: {
      sectionTitle: "우리들의 TOP 10 시리즈",
      images: [
        `${process.env.PUBLIC_URL}/couple/couple1.jpg`,
        `${process.env.PUBLIC_URL}/couple/couple2.jpeg`,
        `${process.env.PUBLIC_URL}/couple/couple3.jpeg`,
        `${process.env.PUBLIC_URL}/couple/couple4.jpg`,
        `${process.env.PUBLIC_URL}/couple/couple5.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-1.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-2.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-3.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-4.jpeg`,
        `${process.env.PUBLIC_URL}/couple/our-memory-5.jpeg`,
      ],
    },
    newHotInfo: {
      videoURL: `${process.env.PUBLIC_URL}/couple.MOV`,
      title: "우리들의 결혼 이야기",
      caption: "6월 15일 새로운 에피소드 공개",
      message: `덥고 먼 길 힘드시겠지만 귀한 걸음 하시어 새롭게 시작될 저희의
              계절을 축복해 주시면 저희에겐 더없는 기쁨이 될 것 같습니다.`,
    },
    heartInfo: {
      sectionTitle: "우리가 찜한 리스트",
      titles: [
        "X",
        "편의점",
        "인생네컷1",
        "인생네컷2",
        "인생네컷2",
        "기차 안에서",
      ],
      images: [
        `${process.env.PUBLIC_URL}/couple/couple1.jpg`,
        `${process.env.PUBLIC_URL}/couple/couple2.jpeg`,
        `${process.env.PUBLIC_URL}/couple/couple3.jpeg`,
        `${process.env.PUBLIC_URL}/couple/couple4.jpg`,
        `${process.env.PUBLIC_URL}/couple/couple5.jpeg`,
      ],
      percents: [30, 20, 50, 80, 70, 10],
    },
    accountInfo: [
      {
        name: "안영훈",
        bankName: "토스뱅크",
        bankImage: `${process.env.PUBLIC_URL}/toss.jpeg`,
        accountNumber: "1001-2634-3421",
        isGroom: true,
        familyName: "",
      },
      {
        name: "박주원",
        bankName: "카카오뱅크",
        bankImage: `${process.env.PUBLIC_URL}/kakaobank.png`,
        accountNumber: "3333-21-2719127",
        isGroom: false,
        familyName: "",
      },
    ],
  },
};
